export enum ActionStatus {
  New = 1,
  InProgress = 2,
  Closed = 3,
}